import { InjectionToken } from '@angular/core';

export const SUGGESTION_COMPARISON_TOKEN = new InjectionToken<SuggestionComparison>('SuggestionComparison');

export interface SuggestionComparison {
  compare: (dataIndexResults: AceAjax.Completion[], algoliaResults: AceAjax.Completion[]) => QualityComparision;
}

export interface QualityComparision {
  algoliaResultCount: number;
  dataIndexResultCount: number;
  hitRate: number;
}
